import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import Utility from '../../util/utilityfunctions';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function TaskDescriptionReducer(
	state = initialState.taskDescription,
	action
) {
	switch (action.type) {
		case types.GET_TASK_DESCRIPTION: {
			let taskDescription = Object.assign({}, action.response)
			taskDescription.description = Utility.getSanitizedText(taskDescription.description);		
			return taskDescription;
		}
		case types.UPDATE_TASK_DESCRIPTION: {
			return state;
		}
		case types.CLEAN_TASK_DESCRIPTION: 
		case types.RESET_TASK_DETAIL:
			return null;
		case types.RESET_TASK_ATTRIBUTES: {
			return null;
		}		
		default:
			return state;
	}
}
